import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { CheckCircle, ArrowRight, ShoppingBag } from 'lucide-react';
import { getApiUrl } from '../config/config';

// --- ANIMACIJE ---
const popIn = keyframes`
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
`;

// --- STILOVI ---
const SuccessContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const SuccessCard = styled.div`
  background: #111111;
  border: 1px solid #333333;
  border-radius: 20px;
  padding: 50px 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  animation: ${popIn} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
`;

const IconWrapper = styled.div`
  width: 100px;
  height: 100px;
  background: rgba(224, 193, 111, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  color: #e0c16f;
  
  svg {
    width: 50px;
    height: 50px;
  }
`;

const Title = styled.h1`
  font-family: var(--font-heading);
  color: #ffffff;
  font-size: 2.5rem;
  margin-bottom: 16px;
`;

const Message = styled.p`
  font-family: var(--font-body);
  color: #aaaaaa;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 40px;
`;

const ActionButton = styled.button`
  background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%);
  color: #000000;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-family: var(--font-heading);
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(224, 193, 111, 0.4);
  }
`;

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Stripe nam šalje ove parametre u URL-u nakon uspešne uplate
  const sessionId = searchParams.get('session_id');
  const paypalToken = searchParams.get('token');
  const [verification, setVerification] = useState(sessionId || paypalToken ? 'checking' : 'complete');
  const [error, setError] = useState('');

  useEffect(() => {
    if (sessionId || paypalToken) {
      const url = sessionId ? `${getApiUrl()}/payments/checkout-session/${encodeURIComponent(sessionId)}` : `${getApiUrl()}/payments/paypal/capture-order`;
      fetch(url, {method:sessionId?'GET':'POST',headers:{Authorization:`Bearer ${localStorage.getItem('token')}`,...(!sessionId?{'Content-Type':'application/json'}:{})},...(!sessionId?{body:JSON.stringify({order_id:paypalToken})}:{})})
        .then(async response => { const data = await response.json(); if (!response.ok) throw new Error(data.error || 'Unable to verify payment'); setVerification('complete'); })
        .catch(err => { setError(err.message); setVerification('error'); });
    }
  }, [sessionId, paypalToken]);

  return (
    <SuccessContainer>
      <SuccessCard>
        <IconWrapper>
          <CheckCircle />
        </IconWrapper>
        <Title>{verification === 'checking' ? 'Verifying payment…' : verification === 'error' ? 'Payment needs review' : 'Payment Successful!'}</Title>
        <Message>
          {verification === 'checking' ? 'Please wait while BUCX confirms your secure checkout.' : verification === 'error' ? error : 'Thank you for your support. Your payment has been verified and recorded.'}
        </Message>
        
        <ActionButton onClick={() => navigate('/')}>
          <ShoppingBag size={20} />
          Back to Home
          <ArrowRight size={20} />
        </ActionButton>
      </SuccessCard>
    </SuccessContainer>
  );
};

export default PaymentSuccess;
